import React from 'react'

export default function OrderShipments(props) {
    // props
    const {
        orderDetails,
        paymentDetails
    } = props

    return (
        <div className="invoices-view">
            {
                ((orderDetails?.tracking_number) && (orderDetails?.tracking_link)) ? (
                    <p className="st-fs-16 p-2">
                        <span className="me-2">Track your order from here:</span>
                        <a
                            href={orderDetails?.tracking_link}
                            target="_blank"
                            rel="noreferrer"
                            className="hover-underline-link text-primary"
                        >
                            {orderDetails?.tracking_number}
                        </a>
                    </p>
                ) : (
                    <React.Fragment>
                        <p className="text-center p-2">no tracking details available</p>
                    </React.Fragment>
                )
            }
        </div>
    )
}
